export const mapStagesToInterviewPlanItems = ({
  stages,
}: {
  stages: {
    id: string;
    isCurrent?: boolean;
    position: number;
    title: string;
    description: string | null;
  }[];
}) =>
  stages.map((stage) => ({
    id: stage.id,
    title: stage.title,
    description: stage.description,
    position: stage.position,
  }));
